import gql from 'graphql-tag'

export const dionePoolsQuery = gql`
  query dionePoolsQuery(
    $first: Int! = 1000
    $skip: Int! = 0
    $orderBy: String! = "id"
    $orderDirection: String! = "desc"
    $block: Block_height
  ) {
    pools(first: $first, skip: $skip, orderBy: $orderBy, orderDirection: $orderDirection, block: $block) {
      id
      pair
      rewarder {
        id
        rewardToken
        rewardPerSecond
      }
      allocPoint
      lastRewardTime
      accNvlsPerShare
      nvlpBalance
      userCount
      dione {
        id
        nvlsPerSecond
        totalAllocPoint
      }
    }
  }
`

export const dionePoolsQueryV2 = gql`
  query dionePoolsQuery(
    $first: Int! = 1000
    $skip: Int! = 0
    $orderBy: String! = "id"
    $orderDirection: String! = "desc"
    $block: Block_height
  ) {
    pools(first: $first, skip: $skip, orderBy: $orderBy, orderDirection: $orderDirection, block: $block) {
      id
      pair
      rewarder {
        id
        rewardToken
        rewardPerSecond
        totalAllocPoint
      }
      allocPoint
      lastRewardTime
      accNvlsPerShare
      nvlpBalance
      userCount
      dione {
        id
        nvlsPerSecond
        totalAllocPoint
      }
    }
  }
`

export const dioneNativeRewarderPoolsQuery = gql`
  query nativeRewarderPools(
    $first: Int! = 1000
    $skip: Int! = 0
    $orderBy: String! = "id"
    $orderDirection: String! = "desc"
  ) {
    nativeRewarderPools(first: $first, skip: $skip, orderBy: $orderBy, orderDirection: $orderDirection) {
      id
      allocPoint
    }
  }
`

export const dionePairAddressesQuery = gql`
  query dionePairAddresses(
    $first: Int! = 1000
    $skip: Int! = 0
    $orderBy: String! = "id"
    $orderDirection: String! = "desc"
    $where: Pool_filter! = { allocPoint_gt: 0, accNvlsPerShare_gt: 0 }
  ) {
    pools(first: $first, skip: $skip, orderBy: $orderBy, orderDirection: $orderDirection, where: $where) {
      id
      allocPoint
      accNvlsPerShare
      pair {
        id
      }
    }
  }
`

export const dionePoolsWithUserQuery = gql`
  query dionePoolsQuery(
    $first: Int! = 1000
    $skip: Int! = 0
    $orderBy: String! = "id"
    $orderDirection: String! = "desc"
    $block: Block_height
  ) {
    pools(first: $first, skip: $skip, orderBy: $orderBy, orderDirection: $orderDirection, block: $block) {
      id
      pair
      rewarder {
        id
        rewardToken
        rewardPerSecond
      }
      allocPoint
      lastRewardTime
      accNvlsPerShare
      nvlpBalance
      userCount
      dione {
        id
        nvlsPerSecond
        totalAllocPoint
      }
      users(first: 1000, orderBy: "amount", orderDirection: "desc") {
        id
        address
        amount
        block
        rewardDebt
        nvlsHarvested
      }
    }
  }
`

export const dionePoolsWithUserQueryV2 = gql`
  query dionePoolsQuery(
    $first: Int! = 1000
    $skip: Int! = 0
    $orderBy: String! = "id"
    $orderDirection: String! = "desc"
    $block: Block_height
  ) {
    pools(first: $first, skip: $skip, orderBy: $orderBy, orderDirection: $orderDirection, block: $block) {
      id
      pair
      rewarder {
        id
        rewardToken
        rewardPerSecond
        totalAllocPoint
      }
      allocPoint
      lastRewardTime
      accNvlsPerShare
      nvlpBalance
      userCount
      dione {
        id
        nvlsPerSecond
        totalAllocPoint
      }
      users(first: 1000, orderBy: "amount", orderDirection: "desc") {
        id
        address
        amount
        block
        rewardDebt
        nvlsHarvested
      }
    }
  }
`
